import { MouseEventHandler, useCallback, useMemo, useState } from 'react';
import { AgGridSortOptions } from 'common/constants';
import { CustomSortParams, CustomSortResult, GridType } from './types';

export const useCustomSort = ({
  api,
  colId
}: CustomSortParams): CustomSortResult => {
  const [currentSort, setCurrentSort] = useState<AgGridSortOptions>(
    AgGridSortOptions.None
  );

  const isSortAscending = currentSort === AgGridSortOptions.Ascending;
  const isSortDescending = currentSort === AgGridSortOptions.Descending;

  const nextSort = useMemo(() => {
    if (isSortAscending) return AgGridSortOptions.Descending;
    if (isSortDescending) return AgGridSortOptions.None;
    return AgGridSortOptions.Ascending;
  }, [isSortAscending, isSortDescending]);

  const handleCustomSort: MouseEventHandler<HTMLDivElement> =
    useCallback(() => {
      setCurrentSort(nextSort);
      api.applyColumnState({
        state: [{ colId, sort: nextSort as GridType }],
        defaultState: { sort: '' as GridType }
      });
    }, [api, colId, nextSort]);

  return { handleCustomSort, isSortAscending, isSortDescending };
};
